import {
  getTrendGraphDateFormat,
  groupBy,
} from "../../../utility/common-methods";
import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
const {
  PIE,
  BAR_HORIZONTAL,
  BAR_VERTICAL,
  BAR_STACKED,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
} = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatDataByMAVTrend = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const groupedDataByName = groupBy(data, "entity_name") || {};
    const groupedDataByDate = groupBy(data, "publish_date") || {};
    const labels = Object.keys(groupedDataByDate); // Labels to be shown coloured(entities).
    const formattedLabel =
      report_type == REPORT_TYPES.SOVMAVTrend
        ? labels.map((d) => getTrendGraphDateFormat(d, "-"))
        : labels;
    const listOfEntities = Object.keys(groupedDataByName);
    const correctedlabels = isLineGraph
      ? getLineGraphFormat(formattedLabel, true)
      : formattedLabel;
    if (graph_type === PIE) {
      const data =
        (listOfEntities &&
          listOfEntities.map((ent, index) => {
            let artCnt = 0;
            groupedDataByName[ent].forEach((el) => {
              artCnt += Number(el.mavcnt);
            });
            return artCnt;
          })) ||
        [];
      return {
        datasets: [
          {
            data,
            backgroundColor: getRandomUniqueColor(data.length),
            label: "Share of voice by trend",
          },
        ],
        labels: listOfEntities,
      };
    } else if (graph_type === WORD_CLOUD) {
      return data.map((el) => {
        return {
          text: el.entity,
          value: parseInt(el.articlecnt, 10),
        };
      });
    } else {
      const listData = listOfEntities || [];
      const graphColors = getRandomUniqueColor(listData.length);
      const datasets = listData.map((entry, index) => {
        let data = labels.map((elm) => {
          const tempArr = groupedDataByDate[elm];
          const currentElmArticleCount =
            (tempArr && tempArr.filter((e) => e.entity_name === entry)[0]) ||
            {};
          return currentElmArticleCount.mavcnt || "0";
        });
        data = isLineGraph ? getLineGraphFormat(data) : data;
        return {
          label: entry,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          data,
          barThickness: "flex",
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        labels: correctedlabels,
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
